'use strict';
angular.module('resourceCenterDeleteManuscriptModule', [])
    .controller('resourceCenterDeleteManuscriptCtrl', ['$scope', '$q', 'trsHttpService', 'trsspliceString', '$modalInstance', 'data', function($scope, $q, trsHttpService, trsspliceString, $modalInstance, data) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                items: data.array,
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            defaultSelectedAll();
        }

        /**
         * [defaultSelectedAll 默认全选]
         * @return {[type]} [description]
         */
        function defaultSelectedAll() {
        	for (var i = 0; i < $scope.data.items.length; i ++) {
        		$scope.data.selectedArray.push($scope.data.items[i]);
        	}
        }

        /**
         * [selectItem 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        $scope.confirm = function() {
        	// if ($scope.data.selectedArray.length == 0) {
        	// 	trsconfirm.alertType('请选择要删除的稿件', '', 'info', false);
        	// 	return;
        	// }
            var SHARECATEGORYID = trsspliceString.spliceString($scope.data.selectedArray, 'SHARECATEGORYID', ',');
            $modalInstance.close(SHARECATEGORYID);
        };

        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);